package com.raouf.mehrguard.web.i18n

internal val PortugueseStrings = mapOf(
    WebStringKey.AppName to "Mehr Guard",
    WebStringKey.AppTagline to "Detector de QRishing Kotlin Multiplatform",
    WebStringKey.MenuMain to "Menu Principal",
    WebStringKey.MenuSecurity to "Segurança",
    WebStringKey.MenuSystem to "Sistema",
    WebStringKey.NavDashboard to "Painel",
    WebStringKey.NavScanMonitor to "Monitor de Varredura",
    WebStringKey.NavScanHistory to "Histórico de Varreduras",
    WebStringKey.NavTrustCentre to "Central de Confiança",
    WebStringKey.NavReports to "Relatórios",
    WebStringKey.NavTraining to "Treinamento",
    WebStringKey.NavSettings to "Configurações",
    WebStringKey.QuickActions to "Ações Rápidas",

    // Hero Section
    WebStringKey.HeroTagline to "Seguro. Offline.",
    WebStringKey.HeroTagline2 to "Defesa Explicável.",
    WebStringKey.HeroDescription to "Mehr Guard analisa ameaças potenciais diretamente no seu hardware. Experimente proteção com latência zero.",

    // Dashboard
    WebStringKey.StartScan to "Iniciar Nova Varredura",
    WebStringKey.ImportImage to "Importar Imagem",
    WebStringKey.ScanQrCode to "Escanear Código QR",
    WebStringKey.SystemHealth to "Saúde do Sistema",
    WebStringKey.ThreatDatabase to "Banco de Dados de Ameaças",
    WebStringKey.Current to "Atual",
    WebStringKey.Active to "Ativo",
    WebStringKey.Threats to "Ameaças",
    WebStringKey.SafeScans to "Varreduras Seguras",
    WebStringKey.EngineActive to "Motor Ativo",
    WebStringKey.EnterpriseProtection to "Proteção Empresarial Ativa",
    WebStringKey.SystemOptimal to "Sistema Otimizado",
    WebStringKey.EngineStatus to "Motor v2.4 • Atualizado 2h atrás",
    WebStringKey.ThreatsBlocked to "Ameaças Bloqueadas",
    WebStringKey.AllSystemsOperational to "Todos os sistemas operacionais",

    // Dashboard Sections
    WebStringKey.SectionOverview to "Visão Geral",
    WebStringKey.SectionSecurity to "Segurança",
    WebStringKey.SectionTraining to "Treinamento",
    WebStringKey.SectionReports to "Relatórios",
    WebStringKey.OfflineReady to "Pronto para Offline",
    WebStringKey.OfflineDescription to "Banco de dados local v2.4.1 ativo. Nenhum dado sai deste dispositivo.",

    // Trust Centre
    WebStringKey.TrustCentreTitle to "Central de Confiança",
    WebStringKey.OfflineGuarantee to "Garantia Offline Rigorosa",
    WebStringKey.OfflineGuaranteeDesc to "A análise do Mehr Guard é executada inteiramente no Neural Engine do seu dispositivo. Os dados de URL nunca saem do seu telefone.",
    WebStringKey.ThreatSensitivity to "Sensibilidade a Ameaças",
    WebStringKey.ResetConfirm to "Isso redefinirá todas as configurações da Central de Confiança para os padrões.",

    // Settings Quick Actions
    WebStringKey.ThreatMonitor to "Monitor de Ameaças",
    WebStringKey.ThreatMonitorDesc to "Visualize ameaças ao vivo e execute auditoria de segurança",
    WebStringKey.TrustCentreDesc to "Configurações de privacidade e sensibilidade a ameaças",
    WebStringKey.ExportReport to "Exportar Relatório",
    WebStringKey.ExportReportDesc to "Gerar relatório de segurança PDF ou JSON",

    // Dashboard Content
    WebStringKey.Analyze to "Analisar",
    WebStringKey.HeuristicEngine to "Motor Heurístico",
    WebStringKey.HighPerformanceEngine to "Motor de Alto Desempenho",
    WebStringKey.RecentScans to "Varreduras Recentes",
    WebStringKey.ViewFullHistory to "Ver Histórico Completo",
    WebStringKey.Status to "Estado",
    WebStringKey.Source to "Origem",
    WebStringKey.Details to "Detalhes",
    WebStringKey.Time to "Hora",
    WebStringKey.Version to "Versão",
    WebStringKey.LastUpdate to "Última Atualização",
    WebStringKey.Signatures to "Assinaturas",
    WebStringKey.CheckForUpdates to "Verificar Atualizações",
    WebStringKey.FeatureOfflineTitle to "Arquitetura Offline-First",
    WebStringKey.FeatureOfflineDesc to "A análise completa é realizada localmente. Sua câmera e dados escaneados nunca tocam um servidor externo, garantindo privacidade absoluta.",
    WebStringKey.FeatureExplainableTitle to "Segurança Explicável",
    WebStringKey.FeatureExplainableDesc to "Não receba apenas um \"Bloqueio\". Fornecemos análises heurísticas detalhadas de parâmetros de URL, redirecionamentos e payloads JavaScript.",
    WebStringKey.FeaturePerformanceDesc to "Otimizado para ambientes desktop. Varreduras são processadas em menos de 5ms usando binários nativos Kotlin Multiplatform.",
    WebStringKey.TrainingCentre to "Centro de Treinamento",
    WebStringKey.LearnHomograph to "Aprenda a identificar ataques homógrafos QR avançados.",
    WebStringKey.BeatTheBotAction to "Vença o Bot →",
    WebStringKey.NoScansYet to "Ainda não há varreduras. Inicie uma nova varredura para ver os resultados aqui.",
    WebStringKey.VerdictSafe to "SEGURO",
    WebStringKey.VerdictPhish to "PHISHING",
    WebStringKey.VerdictWarn to "AVISO",
    WebStringKey.ScoreLabel to "Pontuação:",

    // Scanner
    WebStringKey.ActiveScanner to "Scanner Ativo",
    WebStringKey.OfflineMode to "Modo Offline",
    WebStringKey.LiveFeedDisconnected to "FEED AO VIVO DESCONECTADO",
    WebStringKey.CameraAccessRequired to "Acesso à Câmera Necessário",
    WebStringKey.CameraAccessDescription to "Arraste e solte uma imagem de código QR aqui ou habilite o acesso à câmera para começar a escanear.",
    WebStringKey.EnableCamera to "Habilitar Câmera",
    WebStringKey.Scanning to "Escaneando...",
    WebStringKey.ScanHint to "Mantenha firme. Analisado offline em <5ms.",
    WebStringKey.Torch to "Lanterna",
    WebStringKey.Gallery to "Galeria",
    WebStringKey.PasteUrl to "Colar URL",
    WebStringKey.PasteUrlTitle to "Colar URL para Analisar",
    WebStringKey.AnalyzeUrl to "Analisar URL",
    WebStringKey.SystemStatus to "Status do Sistema",
    WebStringKey.PhishingEngine to "Motor de Phishing",
    WebStringKey.Ready to "PRONTO",
    WebStringKey.LocalDb to "BD Local",
    WebStringKey.Latency to "Latência",
    WebStringKey.ViewAll to "Ver Tudo",

    // Threat / Results
    WebStringKey.BreadcrumbHome to "Início",
    WebStringKey.BreadcrumbScans to "Varreduras",
    WebStringKey.OfflineProtection to "Proteção Offline",
    WebStringKey.VerdictHighRisk to "ALTO RISCO DETECTADO",
    WebStringKey.VerdictDangerous to "Perigoso",
    WebStringKey.VerdictDangerousDesc to "O código QR escaneado contém indicadores maliciosos associados a phishing e coleta de credenciais. Não prossiga para a URL de destino.",
    WebStringKey.ThreatConfidence to "Confiança da Ameaça",
    WebStringKey.FlagPhishing to "Tentativa de Phishing",
    WebStringKey.FlagObfuscated to "Script Ofuscado",
    WebStringKey.FlagHomograph to "Ataque Homógrafo",
    WebStringKey.ClearHistory to "Limpar Tudo",
    WebStringKey.SectionAttackBreakdown to "Análise do Ataque",
    WebStringKey.AttackHomographTitle to "Ataque Homógrafo / IDN",
    WebStringKey.AttackHomographDesc to "Caracteres cirílicos imitando o alfabeto latino detectados.",
    WebStringKey.AttackVisualLabel to "Aparência Visual",
    WebStringKey.AttackPunycodeLabel to "Punycode Real",
    WebStringKey.AttackHomographExplain to "O domínio usa o cirílico 'а' (U+0430) em vez do latino 'a' (U+0061). Esta técnica é comumente usada para enganar usuários fazendo-os acreditar que estão visitando um serviço legítimo.",
    WebStringKey.AttackRedirectTitle to "Cadeia de Redirecionamento Suspeita",
    WebStringKey.AttackRedirectDesc to "3 saltos detectados envolvendo encurtadores de URL conhecidos.",
    WebStringKey.RedirectStart to "Varredura de Código QR",
    WebStringKey.RedirectHop to "Salto Intermediário",
    WebStringKey.RedirectFinal to "Destino Final",
    WebStringKey.AttackJsTitle to "JavaScript Ofuscado",
    WebStringKey.AttackJsDesc to "String de alta entropia detectada nos parâmetros da URL.",
    WebStringKey.SectionActions to "Ações Recomendadas",
    WebStringKey.ActionBlock to "Bloquear e Reportar",
    WebStringKey.ActionBlockDesc to "Prevenir acesso e notificar administrador",
    WebStringKey.ActionQuarantine to "Quarentena em Sandbox",
    WebStringKey.ActionQuarantineDesc to "Abrir com segurança para análise",
    WebStringKey.Expected to "Esperado: ",
    WebStringKey.Detected to "Detectado: ",
    WebStringKey.ExplainableSecurity to "Segurança Explicável",
    WebStringKey.UrlBreakdown to "ANÁLISE DE URL",
    WebStringKey.FullUrl to "URL COMPLETA",
    WebStringKey.OpenInBrowser to "Abrir no Navegador (Arriscado)",
    WebStringKey.OpenWarning to "Abrir esta URL no seu navegador pode expô-lo a riscos de segurança.",
    WebStringKey.RestrictedMode to "Modo Restrito",
    WebStringKey.RestrictedDesc to "Esta URL foi marcada como potencialmente perigosa. Revise a análise abaixo antes de prosseguir.",
    WebStringKey.DangerousWarning to "Esta URL foi marcada como potencialmente perigosa. Abri-la pode expô-lo a phishing, malware ou outras ameaças de segurança. Tem certeza de que deseja prosseguir?",
    WebStringKey.CopyUrl to "Copiar URL",
    WebStringKey.Share to "Compartilhar",
    WebStringKey.Dismiss to "Dispensar",
    WebStringKey.ReasonDomainAge to "A idade do domínio é menor que 24 horas.",
    WebStringKey.ReasonSignatures to "Correspondência com 3 assinaturas no BD de phishing local.",
    WebStringKey.ReasonAsn to "O IP de destino está localizado em um ASN de alto risco.",
    WebStringKey.SectionMeta to "Meta da Varredura",
    WebStringKey.MetaTime to "Hora da Varredura",
    WebStringKey.MetaSource to "Origem",
    WebStringKey.MetaEngine to "Motor",
    WebStringKey.MetaOfflineGuaranteeLabel to "Garantia Offline:",
    WebStringKey.MetaOfflineGuaranteeDesc to "Esta imagem foi analisada localmente no seu dispositivo. Nenhum dado foi enviado para a nuvem para este veredito.",
    
    // Results Page
    WebStringKey.ScanComplete to "Varredura Completa",
    WebStringKey.Loading to "Carregando...",
    WebStringKey.AnalyzedOffline to "Analisado offline em <5ms",
    WebStringKey.NoDataLeaves to "Nenhum dado sai do dispositivo",
    WebStringKey.ActiveProtection to "Proteção Ativa",
    WebStringKey.ConfidenceScore to "Pontuação de Confiança",
    WebStringKey.Analyzing to "ANALISANDO...",
    WebStringKey.ProcessingResults to "Processando resultados da varredura...",
    WebStringKey.RiskAssessment to "Avaliação de Risco",
    WebStringKey.AnalysisTime to "Tempo de Análise",
    WebStringKey.Heuristics to "Heurísticas",
    WebStringKey.TopAnalysisFactors to "Principais Fatores de Análise",
    WebStringKey.Pass to "APROVADO",
    WebStringKey.Info to "INFO",
    WebStringKey.Clean to "LIMPO",
    WebStringKey.ValidSslCertificate to "Certificado SSL Válido",
    WebStringKey.SslCertificateDesc to "Certificado emitido por DigiCert Inc. Sem anomalias na cadeia de confiança.",
    WebStringKey.EstablishedDomain to "Domínio Estabelecido",
    WebStringKey.EstablishedDomainDesc to "Domínio registrado há > 5 anos. Baixa probabilidade de fraude.",
    WebStringKey.BlacklistStatus to "Status da Lista Negra",
    WebStringKey.BlacklistStatusDesc to "Não encontrado em 52 databases de ameaças locais.",
    WebStringKey.BackToDashboard to "Voltar ao Painel",
    WebStringKey.ShareReport to "Compartilhar Relatório",
    WebStringKey.CopyLink to "Copiar Link",
    WebStringKey.LinkCopied to "Link copiado para a área de transferência!",
    
    // Game Page
    WebStringKey.BeatTheBot to "Vença o Bot",
    WebStringKey.BeatTheBotDesc to "Desafie nossa IA offline. Você consegue detectar phishing mais rápido?",
    WebStringKey.SessionId to "ID da Sessão",
    WebStringKey.EndSession to "Encerrar Sessão",
    WebStringKey.Round to "Rodada",
    WebStringKey.BrowserPreview to "Prévia do Navegador",
    WebStringKey.MakeDecision to "Tome sua decisão",
    WebStringKey.Phishing to "Fraude",
    WebStringKey.Legitimate to "Legítimo",
    WebStringKey.LiveHint to "Dica ao Vivo",
    WebStringKey.LiveScoreboard to "Placar ao Vivo",
    WebStringKey.VsMode to "MODO VS",
    WebStringKey.You to "Você",
    WebStringKey.Points to "pt",
    WebStringKey.Streak to "Sequência",
    WebStringKey.Accuracy to "Precisão",
    WebStringKey.MehrGuardBot to "Bot Mehr Guard",
    WebStringKey.Confidence to "Confiança",
    WebStringKey.RoundAnalysis to "Análise da Rodada",
    WebStringKey.Analysis to "Análise",
    WebStringKey.CorrectDecision to "Decisão Correta!",
    WebStringKey.IdentifiedSafe to "Você identificou corretamente a URL segura.",
    WebStringKey.AiNeuralAnalysis to "Análise Neural IA",
    WebStringKey.WhyBotFlagged to "Por que o bot sinalizou",
    WebStringKey.EducationalNote to "Nota Educativa",
    WebStringKey.Correct to "Correto!",
    WebStringKey.SpottedPhishing to "Você detectou corretamente a URL de phishing.",
    WebStringKey.Response to "Resposta",
    WebStringKey.NextRound to "Próxima Rodada",
    WebStringKey.GameOver to "Fim de Jogo!",
    WebStringKey.FinalResults to "Resultados Finais",
    WebStringKey.YourScore to "Sua Pontuação",
    WebStringKey.BotScore to "Pontuação do Bot",
    WebStringKey.BestStreak to "Melhor Sequência",
    WebStringKey.PlayAgain to "Jogar Novamente",
    WebStringKey.ReturnToDashboard to "Voltar ao Painel",
    
    // Export Page
    WebStringKey.ExportSecurityReport to "Exportar Relatório de Segurança",
    WebStringKey.GenerateReport to "Gere relatórios de segurança completos do seu histórico de varreduras.",
    WebStringKey.ReportFormat to "Formato do Relatório",
    WebStringKey.HumanReadable to "Relatório Legível",
    WebStringKey.HumanReadableDesc to "PDF com análise visual e resumo executivo",
    WebStringKey.MachineReadable to "Dados para Máquina",
    WebStringKey.MachineReadableDesc to "Formato JSON para integração SIEM",
    WebStringKey.DateRange to "Período",
    WebStringKey.Last7Days to "Últimos 7 Dias",
    WebStringKey.Last30Days to "Últimos 30 Dias",
    WebStringKey.Last90Days to "Últimos 90 Dias",
    WebStringKey.AllTime to "Todo o Tempo",
    WebStringKey.CustomRange to "Período Personalizado",
    WebStringKey.ReportSections to "Seções do Relatório",
    WebStringKey.ExecutiveSummary to "Resumo Executivo",
    WebStringKey.ThreatBreakdown to "Análise de Ameaças",
    WebStringKey.ScanTimeline to "Cronologia de Varreduras",
    WebStringKey.SafeUrlList to "Lista de URLs Seguras",
    WebStringKey.GenerateExport to "Exportar Relatório",
    
    // Toast / Notifications
    WebStringKey.Success to "Sucesso!",
    WebStringKey.Error to "Erro",
    WebStringKey.Warning to "Aviso",
    WebStringKey.CopiedToClipboard to "Copiado para a área de transferência",
    
    // General Actions
    WebStringKey.Cancel to "Cancelar",
    WebStringKey.Confirm to "Confirmar",
    WebStringKey.Save to "Salvar",
    WebStringKey.Delete to "Excluir",
    WebStringKey.Edit to "Editar",
    WebStringKey.Close to "Fechar",
    WebStringKey.Back to "Voltar",
    WebStringKey.Next to "Próximo",
    WebStringKey.Previous to "Anterior",
    WebStringKey.Submit to "Enviar",
    WebStringKey.Reset to "Redefinir",
    WebStringKey.Clear to "Limpar",
    WebStringKey.Search to "Pesquisar",
    WebStringKey.Filter to "Filtrar",
    WebStringKey.Sort to "Ordenar",
    
    // Accessibility
    WebStringKey.ToggleMenu to "Alternar menu",
    WebStringKey.ToggleTheme to "Alternar tema",
    WebStringKey.Notifications to "Notificações",
    WebStringKey.Help to "Ajuda",
    WebStringKey.Profile to "Perfil",
    WebStringKey.ToggleLightDarkMode to "Alternar modo claro/escuro",
    
    // Placeholders
    WebStringKey.UrlInputPlaceholder to "Cole URL para analisar (ex: https://example.com)",
    WebStringKey.UrlExamplePlaceholder to "https://example.com",
    
    // Export Page Additional
    WebStringKey.Scan to "Varredura",
    WebStringKey.Result to "Resultado",
    WebStringKey.ReportGeneration to "Geração de Relatório",
    WebStringKey.ReportGenerationDesc to "Configure formatos e baixe sua análise de ameaças.",
    WebStringKey.OfflineSecurity to "Segurança Offline",
    WebStringKey.OfflineSecurityDesc to "Seus dados nunca saem deste dispositivo. Todo o processamento é local.",
    WebStringKey.ChooseFormat to "Escolher Formato",
    WebStringKey.PdfFormatDesc to "Formato PDF. Ideal para compartilhamento.",
    WebStringKey.JsonFormatDesc to "Formato JSON. Ideal para integração SIEM.",
    WebStringKey.Copy to "Copiar",
    WebStringKey.LivePreview to "Prévia ao Vivo",
    WebStringKey.ReadOnly to "Somente Leitura",
    WebStringKey.ThreatAnalysisReport to "Relatório de Análise de Ameaças",
    WebStringKey.Verdict to "Veredito",
    WebStringKey.RiskScore to "Pontuação de Risco",
    WebStringKey.TargetUrl to "URL Alvo",
    WebStringKey.AnalysisSummaryLabel to "Resumo da Análise",
    WebStringKey.TechnicalIndicators to "Indicadores Técnicos",
    WebStringKey.ExportInfoNote to "As exportações incluem todos os vetores de ameaça identificados e a análise de payload.",
    
    // Trust Centre Page
    WebStringKey.AllowList to "Lista de Permitidos",
    WebStringKey.BlockList to "Lista de Bloqueados",
    WebStringKey.AddDomain to "Adicionar Domínio",
    WebStringKey.RemoveDomain to "Remover Domínio",
    WebStringKey.TrustedDomains to "Domínios Confiáveis",
    WebStringKey.BlockedDomains to "Domínios Bloqueados",
    WebStringKey.DomainPlaceholder to "Digite o domínio (ex: example.com)",
    
    // Game Page Additional
    WebStringKey.Safe to "Seguro",
    WebStringKey.TimeAgo to "atrás",
    WebStringKey.MinutesAgo to "min atrás",
    WebStringKey.HoursAgo to "h atrás",
    
    // Misc
    WebStringKey.Critical to "CRÍTICO",
    WebStringKey.Warn to "AVISO",
    
    // Trust Centre - Sensitivity
    WebStringKey.PhishingDetectionSensitivity to "Sensibilidade de Detecção de Phishing",
    WebStringKey.SensitivityDescription to "Ajuste os limiares heurísticos. Maior sensibilidade pode aumentar falsos positivos.",
    WebStringKey.SensitivityLow to "Baixo",
    WebStringKey.SensitivityBalanced to "Balanceado",
    WebStringKey.SensitivityParanoia to "Máxima",
    WebStringKey.BalancedModeRecommended to "Modo Balanceado (Recomendado)",
    WebStringKey.BalancedModeDesc to "Procura padrões maliciosos conhecidos e inconsistências heurísticas. Bloqueia ataques homógrafos e cadeias de redirecionamento.",
    WebStringKey.LowSensitivityMode to "Modo de Sensibilidade Baixa",
    WebStringKey.LowSensitivityModeDesc to "Apenas bloqueia URLs maliciosas conhecidas do banco de dados de ameaças. Mínimo de falsos positivos, mas pode perder novos ataques.",
    WebStringKey.ParanoiaMode to "Modo Paranoia",
    WebStringKey.ParanoiaModeDesc to "Proteção máxima. Bloqueia qualquer padrão suspeito incluindo domínios recém-registrados, TLDs incomuns e qualquer URL com possíveis truques de codificação.",
    WebStringKey.PrivacyGuaranteeDesc to "Mehr Guard usa motores de análise heurística locais. Nenhum dado de imagem, string de URL ou metadados sai deste dispositivo durante a verificação. Sua privacidade é matematicamente garantida.",
    WebStringKey.SignalBrandImpersonation to "Possível imitação de marca detectada",
    WebStringKey.SignalCredentialParams to "Parâmetros relacionados a credenciais na URL",
    WebStringKey.SignalEncodedPayload to "Dados codificados detectados em parâmetros de consulta",
    WebStringKey.SignalExcessiveSubdomains to "Profundidade excessiva de subdomínios ({count} níveis)",
    WebStringKey.SignalHighEntropyHost to "Alta aleatoriedade no nome do domínio",
    WebStringKey.SignalHomographAttack to "O domínio contém caracteres homógrafos/confundíveis",
    WebStringKey.SignalHttpNotHttps to "Usa protocolo HTTP inseguro",
    WebStringKey.SignalIpAddressHost to "O host é um endereço IP em vez de domínio",
    WebStringKey.SignalLongUrl to "URL incomumente longa ({length} caracteres)",
    WebStringKey.SignalLongUrlMarketing to "URL incomumente longa ({length} caracteres) - contém parâmetros de marketing",
    WebStringKey.SignalNewlyRegisteredDomain to "Domínio recém-registrado detectado",
    WebStringKey.SignalNonStandardPort to "Porta não padrão: {port}",
    WebStringKey.SignalNumericSubdomain to "Subdomínio apenas numérico detectado",
    WebStringKey.SignalSuspiciousPathKeywords to "Palavras-chave suspeitas no caminho ({count} encontradas)",
    WebStringKey.SignalSuspiciousTld to "TLD suspeito: {tld}",
    WebStringKey.SignalUrlShortener to "Usa serviço de encurtamento de URL",
    WebStringKey.SecureEnvironment to "Ambiente Seguro",
    WebStringKey.LearnLocalArchitecture to "Conheça nossa arquitetura local",
    WebStringKey.NoCustomDomainsBlocked to "Nenhum domínio personalizado bloqueado.",
    WebStringKey.AddManually to "Adicionar manualmente",
    WebStringKey.AddedDaysAgo to "Adicionado há 2 dias",
    WebStringKey.AddedWeekAgo to "Adicionado há 1 semana",
    
    // Trust Centre - Privacy Controls
    WebStringKey.PrivacyControls to "Controles de Privacidade",
    WebStringKey.StrictOfflineMode to "Modo Offline Rigoroso",
    WebStringKey.DisableExternalPreviews to "Desabilitar todas as prévias de links externos.",
    WebStringKey.AnonymousTelemetry to "Telemetria Anônima",
    WebStringKey.ShareDetectionStats to "Compartilhar estatísticas de detecção para melhorar ML.",
    WebStringKey.AutoCopySafeLinks to "Cópia Automática de Links Seguros",
    WebStringKey.CopyTrustedUrls to "Copiar URLs confiáveis para a área de transferência.",
    
    // Trust Centre - About
    WebStringKey.AboutMehrGuard to "Sobre o Mehr Guard",
    WebStringKey.OpenSourceLicenses to "Licenças de Código Aberto",
    WebStringKey.PrivacyPolicy to "Política de Privacidade",
    WebStringKey.Acknowledgements to "Agradecimentos",
    WebStringKey.ResetAllSettings to "Redefinir todas as configurações",
    WebStringKey.AddToAllowlist to "Adicionar à Lista de Permitidos",
    WebStringKey.AddToBlocklist to "Adicionar à Lista de Bloqueados",
    
    // Onboarding
    WebStringKey.AnalysedOfflineTitle to "Analisado offline.",
    WebStringKey.YourDataStaysOnDevice to "Seus dados ficam no dispositivo.",
    WebStringKey.OnboardingHeroDesc to "Mehr Guard processa cada varredura com análise segura no dispositivo. Priorizamos segurança explicável sem telemetria na nuvem.",
    WebStringKey.OnDeviceAnalysis to "Análise no Dispositivo",
    WebStringKey.OnDeviceAnalysisDesc to "Toda a detecção de ameaças é executada localmente no seu dispositivo. Nenhum dado sai do seu sistema.",
    WebStringKey.NoCloudLogs to "Sem Logs na Nuvem",
    WebStringKey.NoCloudLogsDesc to "Desabilitamos rigorosamente a telemetria de saída para varreduras. Os resultados e hashes permanecem locais.",
    WebStringKey.OnDeviceDB to "Database no Dispositivo",
    WebStringKey.OnDeviceDBDesc to "O database completo de assinaturas de ameaças é baixado para seu dispositivo para buscas em milissegundos.",
    WebStringKey.DataLifecycleVerification to "Verificação do Ciclo de Vida dos Dados",
    WebStringKey.SecurityAuditPass to "Auditoria de Segurança: APROVADA",
    
    // Footer
    WebStringKey.Copyright to "© 2025-2026 Mehr Guard Security Inc. Todos os direitos reservados.",
    WebStringKey.Support to "Suporte",
    WebStringKey.Terms to "Termos",
    WebStringKey.SystemsOperational to "Sistemas Operacionais",
    WebStringKey.SystemSecure to "Sistema Seguro",
    
    // Version / Build Info
    WebStringKey.VersionStatus to "v2.4.1 • Sistema Seguro",
    WebStringKey.CoreVersion to "Core v2.4.1 • Build 2025.12.29",
    WebStringKey.VerifiedBy to "Verificado por Mehr Guard Enterprise",
    
    // User Profile (Sample)
    WebStringKey.SampleUserName to "João Silva",
    WebStringKey.SampleUserRole to "Analista de Segurança",
    
    // Export Preview
    WebStringKey.DetailLabel to "Rótulo do Detalhe",
    WebStringKey.DetailValue to "Valor do Detalhe",
    WebStringKey.Suspicious to "Suspeito",
    
    // Game Modal Strings
    WebStringKey.IncorrectDecision to "Decisão Incorreta",
    WebStringKey.WrongAnswer to "Ops! Isso não estava certo.",
    WebStringKey.ResponseTime to "Tempo de Resposta",
    WebStringKey.IncomingMessage to "Mensagem Recebida",
    WebStringKey.CertificateIssuer to "Emissor do certificado corresponde ao proprietário do domínio",
    WebStringKey.DomainAgeTrust to "Idade do domínio > 5 anos (Alta confiança)",
    WebStringKey.WhitelistedRank to "Top 1k Alexa na lista branca local",
    
    // Game Tips/Hints
    WebStringKey.GameEducationalNote to "Nota Educativa",
    WebStringKey.GameHintTitle to "Dica do Jogo",
    
    // Trust Modal
    WebStringKey.AddToAllowlistTitle to "Adicionar à Lista de Permitidos",
    WebStringKey.AddToBlocklistTitle to "Adicionar à Lista de Bloqueados",
    WebStringKey.EnterDomainPrompt to "Digite um domínio para adicionar à sua lista",
    
    // Additional Game Strings
    WebStringKey.LatencyMs to "Latência",
    WebStringKey.StreakFire to "Sequência",
    WebStringKey.AccuracyPercent to "Precisão",
    WebStringKey.ConfidencePercent to "Confiança",
    
    // Languages
    WebStringKey.English to "Inglês",
    WebStringKey.German to "Alemão",
    WebStringKey.Spanish to "Espanhol",
    WebStringKey.French to "Francês",
    WebStringKey.ChineseSimplified to "Chinês (Simplificado)",
    WebStringKey.Japanese to "Japonês",
    WebStringKey.Hindi to "Híndi",
    WebStringKey.Arabic to "Árabe",
    WebStringKey.Indonesian to "Indonésio",
    WebStringKey.Italian to "Italiano",
    WebStringKey.Korean to "Coreano",
    WebStringKey.Portuguese to "Português",
    WebStringKey.Russian to "Russo",
    WebStringKey.Thai to "Tailandês",
    WebStringKey.Turkish to "Turco",
    WebStringKey.Vietnamese to "Vietnamita"
,
    WebStringKey.ComponentVoting to "Votação de Componentes",
    WebStringKey.Heuristic to "Heurística",
    WebStringKey.MLModel to "Modelo ML",
    WebStringKey.Brand to "Marca",
    WebStringKey.TLD to "TLD",
    WebStringKey.VotingExplanation to "Voto majoritário determina o veredito: 3+ SEGURO = verde, 2+ MALICIOSO = vermelho"
,
    // Results Page Placeholders,
    WebStringKey.WaitingForScan to "Aguardando varredura...",
    WebStringKey.WaitingForAnalysis to "Aguardando análise...",
    WebStringKey.ScanURLToSeeResults to "Escaneie uma URL para ver os resultados detalhados.",

    // Keyboard Shortcuts & Settings
    WebStringKey.KeyboardShortcuts to "Atalhos de Teclado",
    WebStringKey.StartScanner to "Iniciar Scanner",
    WebStringKey.CloseMenuModal to "Fechar Menu / Modal",
    WebStringKey.NavigateToDashboard to "Ir para o Painel",
    WebStringKey.NavigateToHistory to "Histórico de Varreduras",
    WebStringKey.NavigateToTrust to "Centro de Confiança / Lista de Permitidos",
    WebStringKey.NavigateToGame to "Jogo Vença o Bot",
    WebStringKey.ShowHelp to "Mostrar Ajuda",
    WebStringKey.GotIt to "Entendi",
    WebStringKey.SecuritySettings to "Configurações de Segurança",
    WebStringKey.SensitivityLevel to "Nível de Sensibilidade",
    WebStringKey.AutoBlockThreats to "Bloquear Ameaças Automaticamente",
    WebStringKey.RealTimeScanning to "Varredura em Tempo Real",
    WebStringKey.SoundAlerts to "Alertas Sonoros",
    WebStringKey.ThreatAlerts to "Alertas de Ameaças",
    WebStringKey.ShowConfidenceScore to "Mostrar Pontuação de Confiança",
    WebStringKey.CompactView to "Visualização Compacta",
    WebStringKey.ResetDefaults to "Restaurar Padrões",
    WebStringKey.SaveAndContinue to "Salvar e Continuar",
    
    // Result Screen Verdicts
    WebStringKey.VerdictSuspicious to "ATIVIDADE SUSPEITA",
    WebStringKey.VerdictWarning to "Aviso",
    WebStringKey.VerdictSuspiciousDesc to "O código QR escaneado mostra padrões suspeitos que podem indicar riscos potenciais de segurança. Prossiga com cautela.",
    WebStringKey.VerdictMinorConcerns to "PREOCUPAÇÕES MENORES",
    WebStringKey.VerdictCaution to "Cuidado",
    WebStringKey.VerdictMinorConcernsDesc to "Algumas preocupações de segurança menores foram identificadas. O link parece principalmente seguro, mas recomenda-se revisão.",
    WebStringKey.VerdictVerifiedSafe to "VERIFICADO SEGURO",
    WebStringKey.VerdictSafeLabel to "Seguro",
    WebStringKey.VerdictVerifiedSafeDesc to "Nenhuma ameaça de segurança detectada. O código QR leva a um destino seguro verificado.",
    WebStringKey.VerdictNoActivity to "Sem Atividade",
    WebStringKey.VerdictAwaitingScan to "Aguardando Escaneamento",
    WebStringKey.VerdictNoActivityDesc to "Nenhum dado de escaneamento disponível. Escaneie um código QR ou insira uma URL para analisar.",
    WebStringKey.ScanQrToSeeActivity to "Escaneie um código QR para ver sua atividade aqui",
    
    // Data Lifecycle Table
    WebStringKey.DataPoint to "Ponto de Dados",
    WebStringKey.ProcessingEnv to "Ambiente de Processamento",
    WebStringKey.ExternalTransmission to "Transmissão Externa",
    WebStringKey.RawImageBuffer to "Buffer de Imagem Bruta",
    WebStringKey.LocalMemoryRam to "Memória Local (RAM)",
    WebStringKey.TransmissionNone to "Nenhuma",
    WebStringKey.DecodedUrlPayload to "URL/Payload Decodificado",
    WebStringKey.LocalAnalysis to "Análise Local",
    WebStringKey.ThreatVerdictLabel to "Veredicto de Ameaça",
    WebStringKey.LocalDatabase to "Banco de Dados Local",

    // Missing Keys - Security Signals & Results
    WebStringKey.AboutDescription to "Sobre o Mehr Guard Security",
    WebStringKey.ActualDomain to "Domínio Real",
    WebStringKey.AnalysisComplete to "Análise Concluída",
    WebStringKey.AutoBlockThreatsDesc to "Bloquear ameaças automaticamente",
    WebStringKey.AwaitingScanLabel to "Aguardando Verificação",
    WebStringKey.BrandImpersonation to "Falsificação de Marca",
    WebStringKey.CautionAdvised to "Cuidado Recomendado",
    WebStringKey.CompactViewDesc to "Vista Compacta",
    WebStringKey.DoNotVisit to "NÃO VISITE",
    WebStringKey.DoNotVisitDesc to "Phishing de alta confiança detectado. Esta URL exibe múltiplos indicadores maliciosos.",
    WebStringKey.DomainUsesInternationalChars to "Este domínio usa caracteres internacionais que podem imitar domínios legítimos.",
    WebStringKey.GoToScanner to "Ir para o Scanner",
    WebStringKey.Hebrew to "Hebraico",
    WebStringKey.HelpKeyboardShortcuts to "Atalhos do Teclado",
    WebStringKey.HeuristicAnalysis to "Análise Heurística",
    WebStringKey.HeuristicAnalysisDesc to "URL marcada com base em múltiplos fatores de risco detectados pelo motor de análise.",
    WebStringKey.HiddenDestination to "Destino Oculto",
    WebStringKey.HighRisk to "Alto Risco",
    WebStringKey.HighRiskLabel to "ALTO RISCO",
    WebStringKey.HomographIdnAttack to "Ataque Homógrafo / IDN",
    WebStringKey.InternationalizedDomainDetected to "Nome de domínio internacionalizado detectado.",
    WebStringKey.JustNow to "Agora mesmo",
    WebStringKey.KeyboardShortcutsDesc to "Atalhos do teclado para acesso rápido",
    WebStringKey.LiveFeedActive to "FEED AO VIVO ATIVO",
    WebStringKey.LowRisk to "Baixo Risco",
    WebStringKey.LowRiskLabel to "BAIXO RISCO",
    WebStringKey.Malicious to "Malicioso",
    WebStringKey.MediumRiskLabel to "RISCO MÉDIO",
    WebStringKey.NoData to "SEM DADOS",
    WebStringKey.NoScanDataResults to "Nenhum dado de verificação disponível. Por favor, verifique uma URL para ver os resultados da análise.",
    WebStringKey.NoUrlScanned to "Nenhuma URL verificada",
    WebStringKey.Persian to "Persa",
    WebStringKey.PhishingIndicators to "Indicadores de Phishing",
    WebStringKey.ProceedWithCaution to "PROSSIGA COM CUIDADO",
    WebStringKey.ProceedWithCautionDesc to "Alguns indicadores suspeitos detectados. Verifique a fonte antes de inserir informações sensíveis.",
    WebStringKey.RealTimeScanningDesc to "Verificação em tempo real",
    WebStringKey.RedirectShortenerDetected to "Redirecionamento/Encurtador Detectado",
    WebStringKey.SafeToVisit to "SEGURO PARA VISITAR",
    WebStringKey.SafeToVisitDesc to "Verificado por heurísticas locais v2.4. Nenhum padrão de phishing, script ofuscado ou correspondência de lista negra encontrado.",
    WebStringKey.SafetyScore to "Pontuação de Segurança",
    WebStringKey.ScanCompleteLabel to "Verificação Concluída",
    WebStringKey.ScanToAnalyze to "Escaneie um código QR ou insira uma URL para analisar.",
    WebStringKey.ScannedURLLabel to "URL Verificada",
    WebStringKey.SecuritySignal to "Sinal de Segurança",
    WebStringKey.SensitivityLevelDesc to "Nível de Sensibilidade",
    WebStringKey.SensitivityPermissive to "Permissivo",
    WebStringKey.SensitivityStrict to "Rigoroso",
    WebStringKey.SettingsDetection to "Detecção",
    WebStringKey.SettingsDisplay to "Exibição",
    WebStringKey.SettingsLanguage to "Idioma",
    WebStringKey.SettingsLanguageDesc to "Selecionar idioma da interface",
    WebStringKey.SettingsNotifications to "Notificações",
    WebStringKey.SettingsSavedAutomatically to "As configurações são salvas automaticamente e sincronizadas entre sessões.",
    WebStringKey.ShowConfidenceScoreDesc to "Mostrar pontuação de confiança",
    WebStringKey.SoundAlertsDesc to "Alertas sonoros",
    WebStringKey.SuspiciousDomain to "Domínio Suspeito",
    WebStringKey.SuspiciousEncoding to "Codificação Suspeita",
    WebStringKey.SuspiciousKeywords to "Palavras-chave Suspeitas",
    WebStringKey.SuspiciousTld to "TLD Suspeito",
    WebStringKey.SuspiciousTldDesc to "O domínio usa {tld} TLD comumente associado a sites maliciosos.",
    WebStringKey.SuspiciousUrlParams to "Parâmetros de URL Suspeitos",
    WebStringKey.SuspiciousUrlParamsDesc to "A URL contém parâmetros complexos ou potencialmente ofuscados.",
    WebStringKey.ThreatAlertsDesc to "Alertas de ameaças",
    WebStringKey.ThreatDetected to "Ameaça Detectada",
    WebStringKey.UnableToDetermine to "Não foi possível determinar o veredicto. Por favor, tente novamente.",
    WebStringKey.Unknown to "Desconhecido",
    WebStringKey.UnknownURL to "URL Desconhecida",
    WebStringKey.UrlShortenerDesc to "A URL usa um serviço de encurtamento que oculta o destino final.",
    WebStringKey.UrlShortenerDetected to "Encurtador de URL Detectado",
    WebStringKey.VersionOfflineReady to "Pronto para offline",
    WebStringKey.VisualAppearance to "Aparência Visual",
    WebStringKey.WaitingForAnalysisLabel to "Aguardando análise...",

    // Reason Code Titles and Descriptions (for i18n of attack analysis cards)
    // CRITICAL severity
    WebStringKey.ReasonJavascriptUrlTitle to "URL JavaScript",
    WebStringKey.ReasonJavascriptUrlDesc to "Esquema de URL JavaScript detectado - executa código quando clicado",
    WebStringKey.ReasonDataUriTitle to "Data URI",
    WebStringKey.ReasonDataUriDesc to "Esquema Data URI detectado - pode conter código malicioso incorporado",
    WebStringKey.ReasonAtSymbolInjectionTitle to "Injeção de Símbolo @",
    WebStringKey.ReasonAtSymbolInjectionDesc to "URL contém símbolo @ indicando possível tentativa de roubo de credenciais",
    // HIGH severity
    WebStringKey.ReasonHomographTitle to "Ataque Homógrafo",
    WebStringKey.ReasonHomographDesc to "Nome de domínio internacionalizado (IDN) pode estar imitando outro domínio",
    WebStringKey.ReasonMixedScriptTitle to "Script Misto",
    WebStringKey.ReasonMixedScriptDesc to "Hostname contém caracteres de múltiplos scripts (possível spoofing)",
    WebStringKey.ReasonLookalikeCharsTitle to "Caracteres Similares",
    WebStringKey.ReasonLookalikeCharsDesc to "Domínio contém caracteres Unicode que parecem letras ASCII",
    WebStringKey.ReasonZeroWidthCharsTitle to "Caracteres de Largura Zero",
    WebStringKey.ReasonZeroWidthCharsDesc to "Caracteres Unicode ocultos de largura zero detectados (tentativa de ofuscação)",
    WebStringKey.ReasonIpHostTitle to "Host IP",
    WebStringKey.ReasonIpHostDesc to "URL usa endereço IP em vez de nome de domínio",
    WebStringKey.ReasonCredentialParamTitle to "Parâmetro de Credencial",
    WebStringKey.ReasonCredentialParamDesc to "URL contém parâmetros relacionados a credenciais (senha, token, etc.)",
    WebStringKey.ReasonBrandImpersonationTitle to "Personificação de Marca",
    WebStringKey.ReasonBrandImpersonationDesc to "URL parece estar personificando uma marca conhecida",
    WebStringKey.ReasonBrandInSubdomainTitle to "Marca no Subdomínio",
    WebStringKey.ReasonBrandInSubdomainDesc to "Nome da marca aparece no subdomínio mas não no domínio principal",
    WebStringKey.ReasonRiskyExtensionTitle to "Extensão Arriscada",
    WebStringKey.ReasonRiskyExtensionDesc to "Caminho contém extensão de arquivo potencialmente perigosa",
    WebStringKey.ReasonDoubleExtensionTitle to "Extensão Dupla",
    WebStringKey.ReasonDoubleExtensionDesc to "Extensão de arquivo dupla detectada (tática comum de malware)",
    WebStringKey.ReasonEncodedPayloadTitle to "Payload Codificado",
    WebStringKey.ReasonEncodedPayloadDesc to "Dados codificados grandes detectados nos parâmetros da URL",
    // MEDIUM severity
    WebStringKey.ReasonHttpNotHttpsTitle to "HTTP não HTTPS",
    WebStringKey.ReasonHttpNotHttpsDesc to "URL usa protocolo HTTP inseguro em vez de HTTPS",
    WebStringKey.ReasonSuspiciousTldTitle to "TLD Suspeito",
    WebStringKey.ReasonSuspiciousTldDesc to "Domínio de nível superior é frequentemente usado para phishing",
    WebStringKey.ReasonHighEntropyHostTitle to "Host de Alta Entropia",
    WebStringKey.ReasonHighEntropyHostDesc to "Nome de domínio parece gerado aleatoriamente",
    WebStringKey.ReasonRedirectParamTitle to "Parâmetro de Redirecionamento",
    WebStringKey.ReasonRedirectParamDesc to "URL contém parâmetro de redirecionamento que pode levar a outro site",
    WebStringKey.ReasonDeepSubdomainTitle to "Subdomínio Profundo",
    WebStringKey.ReasonDeepSubdomainDesc to "Profundidade excessiva de subdomínio (pode ocultar domínio real)",
    WebStringKey.ReasonMultiTldTitle to "Multi TLD",
    WebStringKey.ReasonMultiTldDesc to "Múltiplos segmentos semelhantes a TLD no nome de domínio",
    WebStringKey.ReasonNumericSubdomainTitle to "Subdomínio Numérico",
    WebStringKey.ReasonNumericSubdomainDesc to "Subdomínio apenas numérico detectado",
    WebStringKey.ReasonNonStandardPortTitle to "Porta Não Padrão",
    WebStringKey.ReasonNonStandardPortDesc to "URL usa número de porta não padrão",
    WebStringKey.ReasonSuspiciousPortTitle to "Porta Suspeita",
    WebStringKey.ReasonSuspiciousPortDesc to "URL usa porta comumente associada a ataques",
    WebStringKey.ReasonFragmentHidingTitle to "Ocultação de Fragmento",
    WebStringKey.ReasonFragmentHidingDesc to "Fragmento da URL parece ocultar conteúdo adicional",
    WebStringKey.ReasonExcessiveEncodingTitle to "Codificação Excessiva",
    WebStringKey.ReasonExcessiveEncodingDesc to "Codificação excessiva de URL detectada (tentativa de ofuscação)",
    WebStringKey.ReasonDomainAgePatternTitle to "Padrão de Idade do Domínio",
    WebStringKey.ReasonDomainAgePatternDesc to "Nome de domínio corresponde a padrões de domínios gerados automaticamente",
    // LOW severity
    WebStringKey.ReasonUrlShortenerTitle to "Encurtador de URL",
    WebStringKey.ReasonUrlShortenerDesc to "URL usa serviço de encurtamento (oculta destino real)",
    WebStringKey.ReasonSuspiciousPathTitle to "Caminho Suspeito",
    WebStringKey.ReasonSuspiciousPathDesc to "Caminho contém palavras-chave suspeitas (login, verify, etc.)",
    WebStringKey.ReasonLongUrlTitle to "URL Longa",
    WebStringKey.ReasonLongUrlDesc to "URL anormalmente longa",
    WebStringKey.ReasonCredentialKeywordsTitle to "Palavras-chave de Credenciais",
    WebStringKey.ReasonCredentialKeywordsDesc to "URL contém palavras-chave de coleta de credenciais",
    // INFO
    WebStringKey.ReasonUnparseableTitle to "URL Não Analisável",
    WebStringKey.ReasonUnparseableDesc to "URL não pôde ser completamente analisada",
    WebStringKey.ReasonAnalysisCompleteTitle to "Análise Concluída",
    WebStringKey.ReasonAnalysisCompleteDesc to "Análise concluída com sucesso",

    // ML Score Labels
    WebStringKey.MlPhishingScore to "Pontuação ML de Phishing",
    WebStringKey.MlCharacterAnalysis to "Análise de caracteres",
    WebStringKey.MlFeatureAnalysis to "Análise de recursos",

    // Unicode Attack Breakdowns (Red Team scenarios)
    WebStringKey.IdnPunycodeDomainTitle to "Domínio IDN / Punycode",
    WebStringKey.IdnPunycodeDomainDesc to "Este domínio utiliza caracteres internacionalizados. Exibição segura:",
    WebStringKey.MixedScriptAttackTitle to "Ataque de Scripts Mistos",
    WebStringKey.MixedScriptAttackDesc to "O domínio contém caracteres de múltiplos scripts (ex. Cirílico + Latino). Comum em ataques homógrafos.",
    WebStringKey.ConfusableCharsTitle to "Caracteres Confundíveis",
    WebStringKey.ConfusableCharsDesc to "O domínio contém caracteres semelhantes a letras comuns (ex. 'а' vs 'a')."
)

internal val PortugueseCommonStrings = mapOf(
    "Engine Active" to "Motor Ativo",
    "Enterprise Protection Active" to "Proteção Empresarial Ativa",
    "Start New Scan" to "Iniciar Nova Varredura",
    "Import Image" to "Importar Imagem",
    "System Health" to "Saúde do Sistema",
    "Threat Database" to "Banco de Dados de Ameaças",
    "Current" to "Atual",
    "Heuristic Engine" to "Motor Heurístico",
    "Active" to "Ativo",
    "Threats" to "Ameaças",
    "Safe Scans" to "Varreduras Seguras",
    "Recent Scans" to "Varreduras Recentes",
    "View Full History" to "Ver Histórico Completo",
    "Status" to "Status",
    "Source" to "Origem",
    "Details" to "Detalhes",
    "Time" to "Hora",
    "SAFE" to "SEGURO",
    "SUSPICIOUS" to "SUSPEITO",
    "PHISHING" to "PHISHING",
    "UNKNOWN" to "DESCONHECIDO",
    "Version" to "Versão",
    "Last Update" to "Última Atualização",
    "Signatures" to "Assinaturas",
    "Check for Updates" to "Verificar Atualizações",
    "Active Scanner" to "Scanner Ativo",
    "Offline Mode" to "Modo Offline",
    "Camera Access Required" to "Acesso à Câmera Necessário",
    "Enable Camera" to "Habilitar Câmera",
    "Scanning..." to "Escaneando...",
    "Torch" to "Lanterna",
    "Gallery" to "Galeria",
    "Paste URL" to "Colar URL",
    "Analyze URL" to "Analisar URL",
    "Analyze" to "Analisar",
    "READY" to "PRONTO",
    "Local DB" to "BD Local",
    "Latency" to "Latência",
    "View All" to "Ver Tudo",
    "Dashboard" to "Painel",
    "Settings" to "Configurações",
    "Training Centre" to "Centro de Treinamento",
    "Beat the Bot" to "Vença o Bot",
    "Safe" to "Seguro",
    "Suspicious" to "Suspeito",
    "Dangerous" to "Perigoso",
    "Phishing" to "Phishing",
    "Legitimate" to "Legítimo",
    "Block & Report" to "Bloquear e Reportar",
    "Copy Link" to "Copiar Link",
    "Share" to "Compartilhar",
    "Export Report" to "Exportar Relatório",
    "Clear All" to "Limpar Tudo",
    "Cancel" to "Cancelar",
    "Close" to "Fechar",
    "Back to Dashboard" to "Voltar ao Painel",
    "Scan Complete" to "Varredura Completa",
    "High Risk" to "Alto Risco",
    "Low Risk" to "Baixo Risco",
    "Risk Score" to "Pontuação de Risco",
    "Confidence" to "Confiança",
    "Homograph Attack" to "Ataque Homógrafo",
    "Detected" to "Detectado",
    "Português" to "Português"
)
